module.exports = __webpack_public_path__ + "media/8.5df515a0.mp3";